import React, { ReactNode } from "react";
import IconRenderer from "../util/icon-renderer";

interface SidebarItemProps {
  icon?: ReactNode | string;
  children: ReactNode;
  onClick?: () => void;
  isActive?: boolean;
  isChild?: boolean;
  disabled?: boolean;
}

const SidebarItem: React.FC<SidebarItemProps> = ({
  icon,
  children,
  onClick,
  isActive = false,
  isChild = false,
  disabled,
}) => {
  return (
    <div
      onClick={!disabled ? onClick : undefined}
      className={`flex items-center gap-3 p-2 cursor-pointer hover:bg-[#295C56] hover:w-11/12 hover:rounded-xl
        ${
          disabled
            ? "opacity-50 cursor-not-allowed"
            : "cursor-pointer hover:bg-[#295C56] hover:w-11/12 hover:rounded-xl"
        }
          ${
            isActive && !isChild
              ? "text-[#AACC54] bg-[#295C56] rounded-xl w-11/12 border-l-4 border-l-[#AACC54]"
              : isActive && isChild
              ? "text-[#AACC54] w-11/12 border-b-2 border-b-[#AACC54]"
              : ""
          }
        `}
    >
      <IconRenderer icon={icon} size={18} />
      <span className="text-sm font-medium">{children}</span>
    </div>
  );
};

export default SidebarItem;
